"use strict";

var _require = require('./get-current-date'),
  getCurrentDate = _require.getCurrentDate;
var encodeState = function encodeState(obj) {
  try {
    var stateObject = Object.assign({}, obj, {
      timestamp: getCurrentDate().valueOf()
    });
    return window.btoa(JSON.stringify(stateObject));
  } catch (e) {
    console.error(e);
    return '';
  }
};
module.exports = {
  encodeState: encodeState
};